import React from "react";

function SkinColorIcon() {
  return (
    <path
      d="m 447.95976,181.38697 v 126.28724 c 0,4.55901 -0.18292,8.96325 -0.52064,13.24084 -6.69779,83.90538 -77.09503,113.42634 -129.10145,159.00234 a 84.088321,84.088322 0 0 1 -112.04742,0 C 153.73507,433.84891 82.380995,404.18724 77.005886,318.21341 q -0.337719,-5.13593 -0.337719,-10.55326 V 181.38697 c 0,-0.42215 0,-0.85836 0,-1.28047 0.4362,-65.89452 35.824803,-122.994659 87.451313,-151.460302 1.66038,-0.928685 45.51969,-18.193807 67.96292,-19.1506374 2.22323,-0.140709 4.46051,-0.182921 6.72596,-0.182921 h 47.0112 a 155.87858,155.87859 0 0 1 103.08418,39.2721714 161.53514,161.53514 0 0 1 12.42471,12.04478 176.45039,176.45038 0 0 1 46.43432,111.160949 v 0 q 0.19699,4.77007 0.19699,9.59643 z"
      style={{
        fill: "none",
        stroke: "#18181b",
        strokeWidth: "10",
        strokeDasharray: "none",
        strokeOpacity: "1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    />
  );
}

export default SkinColorIcon;
